import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';

import { COLORS3, FONT, SPACING } from '../../styles/emotion';

export const tooltipAnimation = keyframes`
  0% {
    bottom: -10px;
    opacity: 0;
  }
  100% {
    bottom: 0;
    opacity: 1;
  }
`;

const tooltipContainerWidth = '125px';
const tooltipArrowHeight = '9px';

export const TooltipContainer = styled.div`
  width: ${tooltipContainerWidth};
`;

export const Tooltip = styled.div<{ popIn?: boolean }>`
  background-color: ${COLORS3.BLACK_100};
  border-radius: ${SPACING.XS};
  color: ${COLORS3.WHITE_100};
  font-size: ${FONT.SIZE.EXTRA_SMALL};
  font-weight: ${FONT.WEIGHT.REGULAR};
  padding: 5px 10px;
  position: relative;
  text-align: center;

  ${({ popIn }) =>
    popIn
      ? css`
          animation-name: ${tooltipAnimation};
          animation-delay: 0s;
          animation-duration: 0.5s;
          animation-fill-mode: both;
          animation-timing-function: ease-in;
          display: inline-block;
        `
      : 'display: none;'}

  &::before {
    content: '';

    border-left: ${tooltipArrowHeight} solid transparent;
    border-right: ${tooltipArrowHeight} solid transparent;
    border-top: ${tooltipArrowHeight} solid ${COLORS3.BLACK_100};
    bottom: calc(-1 * (${tooltipArrowHeight} - 1px));
    height: 0;
    left: 0;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    right: 0;
    width: 0;
  }
`;
